// Bound the fan-out from a dashboard in this browser tab. Server-side tenant
// authorization still belongs to each request; this queue stores no results.
const MAX_CONCURRENT_REQUESTS = 4
const pending = []
let active = 0

export function queueDashboardRequest(request, signal) {
  return new Promise((resolve, reject) => {
    pending.push({ request, signal, resolve, reject })
    drain()
  })
}

function drain() {
  while (active < MAX_CONCURRENT_REQUESTS && pending.length) {
    const { request, signal, resolve, reject } = pending.shift()
    if (signal.aborted) {
      reject(signal.reason)
      continue
    }

    active += 1
    Promise.resolve().then(request).then(resolve, reject).finally(() => {
      active -= 1
      drain()
    })
  }
}
